var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteGroup4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.002,
    height: 26.19,
    viewBox: "0 0 36.002 26.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "translate(7058.5 84.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M33.81,9.63a4.17,4.17,0,0,0-2.91-3C28.32,6,18,6,18,6S7.68,6,5.1,6.69a4.17,4.17,0,0,0-2.91,3,43.5,43.5,0,0,0-.69,7.935,43.5,43.5,0,0,0,.69,7.995A4.17,4.17,0,0,0,5.1,28.5c2.58.69,12.9.69,12.9.69s10.32,0,12.9-.69a4.17,4.17,0,0,0,2.91-3,43.5,43.5,0,0,0,.69-7.875,43.5,43.5,0,0,0-.69-8Z",
    transform: "translate(-7058.5 -88.845)",
    fill: "none",
    stroke: "#fcfcfc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M14.625,22.53l8.625-4.905-8.625-4.9Z",
    transform: "translate(-7058.5 -88.845)",
    fill: "none",
    stroke: "#fcfcfc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteGroup4);
export default __webpack_public_path__ + "static/media/WhiteGroup4.8f4fc57c287a3b788e103984e34c4f78.svg";
export { ForwardRef as ReactComponent };